import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import ApexCharts from 'apexcharts';
import Chart from 'react-apexcharts';
import PropTypes from 'prop-types';
import chartData from "./bajaj-area-chart";
import spendingsData from './spendings';
const TotalGrowthBarChart = ({ isLoading, subCountiesData }) => {
    const theme = useTheme();
    const customization = useSelector((state) => state.customization);
    const { primary } = theme.palette.text;
    const darkLight = theme.palette.primary.main;
    const grey200 = theme.palette.grey[200];
    const grey500 = theme.palette.grey[500];
    const primary200 = theme.palette.primary[200];
    const primaryDark = theme.palette.primary.dark;
    const secondaryMain = theme.palette.secondary.main;
    const secondaryLight = theme.palette.secondary.light;
console.log(" is this data available ", JSON.stringify(subCountiesData))

    var colors = [
        '#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800'
      ];
    
    const countiesData = {  
        type: "bar", 
        series: [{
          data: subCountiesData.map(county=>county.TOTAL_AMOUNT)
        }],
        options: {
          chart: {
            height: 250,
            type: "bar",
            events: {
              click: function(chart, w, e) {
              }
            }
          },
          colors: colors,
          plotOptions: {
            bar: {
              columnWidth: '45%',
              distributed: true,
            }
          },
          dataLabels: {
            enabled: false
          },
          legend: {
            show: false,
            position: 'right'
          },
          xaxis: {
            categories: subCountiesData.map(county=>county.SUBCOUNTY_NAME),
            labels: {
              style: {
                colors: colors,
                fontSize: '12px'
              }
            }
          }
        },
    }



    useEffect(() => {
        const newChartData = {
            ...countiesData.options,
            colors: [primary200, primaryDark, secondaryMain, secondaryLight],
            xaxis: {
                labels: {
                    style: {
                        colors: [primary, primary, primary, primary, primary, primary, primary, primary, primary, primary, primary, primary]
                    }
                }
            },
            yaxis: {
                labels: {
                    style: {
                        colors: [primary]
                    }
                }
            },
            grid: {
                borderColor: grey200
            },
            tooltip: {
                theme: 'light'
            },
            legend: {
                labels: {
                    colors: grey500
                }
            }
        };

        // do not load chart when loading
        if (!isLoading) {
            ApexCharts.exec(`bar`, 'updateOptions', newChartData);
        }
    }, [primary200, primaryDark, secondaryMain, secondaryLight, primary, darkLight, grey200, isLoading, grey500]);

    return (
        <>
            <Chart {...countiesData} />
        </>
    );
};

TotalGrowthBarChart.propTypes = {
    isLoading: PropTypes.bool
};

export default TotalGrowthBarChart;